(() => {
    const SELECTOR = '[data-section-type="mo-faq-list"]';
    const STATE_KEY = 'moFaqListBootstrap';

    function hasFaqList(root = document) {
        return Boolean(root.querySelector(SELECTOR) || root.matches?.(SELECTOR));
    }

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) {
                if (existing.dataset.loaded === 'true') {
                    resolve();
                    return;
                }

                existing.addEventListener('load', () => resolve(), { once: true });
                existing.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
                return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.defer = true;
            script.dataset.loaded = 'false';
            script.addEventListener('load', () => {
                script.dataset.loaded = 'true';
                resolve();
            }, { once: true });
            script.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
            document.head.appendChild(script);
        });
    }

    async function initIfNeeded(root = document) {
        if (!hasFaqList(root)) return;

        const src = window.__MO_FAQ_LIST_SRC;
        if (!src) {
            console.warn('[FAQ list] Missing controller asset URL.');
            return;
        }

        const state = window[STATE_KEY] || (window[STATE_KEY] = {});
        state.loadingPromise = state.loadingPromise || loadScript(src);

        try {
            await state.loadingPromise;
            window.MoFaqList?.initAll?.(root);
        } catch (err) {
            console.warn('[FAQ list] Bootstrap failed.', err);
        }
    }

    window.MoFaqListBootstrap = {
        initIfNeeded,
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initIfNeeded(document), { once: true });
    } else {
        initIfNeeded(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
        initIfNeeded(event.target || document);
    });
})();
